var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenGlare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 277,
    viewBox: "0 0 351 277",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3629_56181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513 248.162V276.743H240.2L513 248.162Z",
    fill: "#d6bcfa08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.443 144.682L505.183 199.05L236.866 255.768L487.443 144.682Z",
    fill: "#d6bcfa08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431 54.1279L464.757 100.366L227.166 236.841L431 54.1279Z",
    fill: "#d6bcfa08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.208 -14.6414L395.664 18.9574L212.09 221.82L349.208 -14.6414Z",
    fill: "#d6bcfa08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.059 -54.8773L304.683 -37.2205L193.074 212.182L250.059 -54.8773Z",
    fill: "#d6bcfa08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.284 -62.6577H200.716L172 208.863L143.284 -62.6577Z",
    fill: "#d6bcfa08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3169 -37.2205L93.9407 -54.8773L150.926 212.182L39.3169 -37.2205Z",
    fill: "#d6bcfa08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-51.6641 18.9574L-5.20831 -14.6414L131.91 221.82L-51.6641 18.9574Z",
    fill: "#d6bcfa08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-120.757 100.366L-87.0003 54.1279L116.818 236.841L-120.757 100.366Z",
    fill: "#d6bcfa08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-161.183 199.05L-143.443 144.682L107.134 255.768L-161.183 199.05Z",
    fill: "#d6bcfa08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.8 276.743H-169V248.162L103.8 276.743Z",
    fill: "#d6bcfa08"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3629_56181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 682,
    height: 339.401,
    fill: "white",
    transform: "translate(-169 -62.6577)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenGlare);
export default __webpack_public_path__ + "static/media/TokenGlare.be1c547e58eeaec0e6736639c6d71a5e.svg";
export { ForwardRef as ReactComponent };